import { AnyAction } from 'redux';
import { NewHireActionTypes, NewHireStep } from './models/new-hire-model';
import { NewHireState } from './models/new-hire-state-model';

const initialState: NewHireState = {
    currentStep: NewHireStep.PersonalInfo,
    savedFormValues: undefined,
    isReview: false,
    bishopDetails: null,
    bishopDetailsLoaded: false,
};

export const newHireReducer = (state = initialState, action: AnyAction): NewHireState => {

    switch (action.type) {
        case NewHireActionTypes.CLEAR_NEW_HIRE_STATE:
            return {
                ...initialState,
            };
        case NewHireActionTypes.SET_STEP:
            return {
                ...state,
                currentStep: action.payload,
            };
        case NewHireActionTypes.SET_IS_REVIEW:
            return {
                ...state,
                isReview: action.payload,
            };
        case NewHireActionTypes.SET_BISHOP_DETAILS:
            return {
                ...state,
                bishopDetails: action.payload,
                bishopDetailsLoaded: true,
            };
        case NewHireActionTypes.CLEAR_BISHOP_DETAILS:
            return {
                ...state,
                bishopDetails: null,
                bishopDetailsLoaded: false,
            };

        default: return state;
    }
};

export const clearNewHireState = () => {
    return {
        type: NewHireActionTypes.CLEAR_NEW_HIRE_STATE,
    };
};

export const setNewHireStep = (step: NewHireStep) => {
    return {
        type: NewHireActionTypes.SET_STEP,
        payload: step,
    };
};

export const setIsReview = (isReview: boolean) => {
    return {
        type: NewHireActionTypes.SET_IS_REVIEW,
        payload: isReview,
    };
};

export const setBishopDetails = (data: any) => {
    return {
        type: NewHireActionTypes.SET_BISHOP_DETAILS,
        payload: data,
    };
};

export const clearBishopDetails = () => {
    return {
        type: NewHireActionTypes.CLEAR_BISHOP_DETAILS,        
    };
};